import React from "react";
import { Translate, I18n } from "react-redux-i18n";
import { FaQuestionCircle } from "react-icons/fa";
import { connect } from "react-redux";

import "./styles/FaqList.css";
import alertify from "alertifyjs";
import "./styles/Alertify.css";
import "./styles/AlertifyTheme.css";
import "./styles/Alertify.min.css";
import "./styles/AlertifyTheme.min.css";

import * as actions from "../redux/actions/faqQuestionActions";
import FaqCard from "./FaqCard";
import MiniLoader from "./MiniLoader";

class FaqListQuestion extends React.Component {
  onClickLoadMore = async () => {
    try {
      await this.props
        .LoadMoreFaqQuestion(this.props.pageCount, this.props.user_id, this.props.token)
        .then(() => {
          if (this.props.error) {
            alertify.warning(I18n.t(this.props.error));
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    const { faqList } = this.props;

    if (!faqList || faqList.length === 0) {
      return (
        <div className="faq-empty">
          <FaQuestionCircle className="faq-empty__icon" aria-hidden="true" />
          <p className="faq-empty__text">
            <Translate value="faq_question_not_list" />
          </p>
        </div>
      );
    }

    return (
      <React.Fragment>
        <div className="faq-list">
          {faqList.map((item) => (
            <FaqCard key={item.Id} item={item} />
          ))}
        </div>
        {this.props.pageSize > 4 && (
          this.props.loadingMore ? (
            <div className="faq-load-more">
              <MiniLoader />
            </div>
          ) : (
            <div className="faq-load-more">
              <button
                type="button"
                className="faq-load-more-btn"
                onClick={this.onClickLoadMore}
              >
                <Translate value="load_more" />
              </button>
            </div>
          )
        )}
      </React.Fragment>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,
    error: reducer.faqQuestion.error,
    pageCount: reducer.faqQuestion.page_count,
    loadingMore: reducer.faqQuestion.loadingMore,
    pageSize: reducer.faqQuestion.page_size,
  };
}

const mapDispatchToProps = (dispatch) => ({
  LoadMoreFaqQuestion: (page_count, user_id, token) =>
    dispatch(actions.loadListScroll({ page_count, user_id, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(FaqListQuestion);
